import moment from "moment/moment";
import { useState } from "react";
import { Link } from "react-router-dom";
import useDebounse from "../../helpers/useDebounse";
import { useGetPageQuery } from "../../redux/services/crmAPI";

import { PaginatedItems } from "../../components/pagination/Pagination";

const Exchanges = () => {
    const [selectedStore, setSelectedStore] = useState(0);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [ordersList, setOrdersList] = useState([]);

    const debounceSearch = useDebounse(search, 1000);

    const storeIdParams = "&store_id=" + selectedStore;
    const pagination = "&page=" + currentPage;
    const searchParams = search.length > 0 ? `&search=${debounceSearch}` : "";

    const paramsCombainer = searchParams + pagination + storeIdParams;

    const { data: stores } = useGetPageQuery("stores?per_page=200");
    const { data: orders, refetch: refetchOrders } = useGetPageQuery(
        "orders?type=exchange&order_status_id=0" + paramsCombainer
    );

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setOrdersList([...ordersList, e.target.value]);
        } else if (!e.target.checked) {
            setOrdersList([...ordersList.filter((id) => id !== e.target.value)]);
        }
    };

    const checkAllHandler = () => {
        setOrdersList(orders.data.map((order) => order.id.toString()));
    };

    return (
        <>
            {stores && orders && (
                <div>
                    <div className="content">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div className="d-flex align-items-center">
                                    <h1>Обміни</h1>
                                    <div>
                                        <select
                                            className="form-select mx-2"
                                            value={selectedStore}
                                            onChange={(e) => setSelectedStore(e.target.value)}
                                        >
                                            <option
                                                value={0}
                                                className="dropdown-item active"
                                            >
                                                Всі магазини
                                            </option>
                                            {stores.data.map((store) => {
                                                return (
                                                    <option
                                                        key={store.id}
                                                        value={store.id}
                                                        className="dropdown-item"
                                                    >
                                                        {store.title}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="float-end  mx-2">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Пошук..."
                                            onChange={(e) => setSearch(e.target.value)}
                                            value={search}
                                        />
                                        <button className="btn btn-outline-secondary">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <a
                                className="check_all"
                                onClick={checkAllHandler}
                            >
                                Виділити все
                            </a>
                            <div className="row">
                                <div className="col-12">
                                    <form
                                        id="list_form"
                                        method="post"
                                    >
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th data-field="check"></th>
                                                    <th data-field="id">Замовлення</th>
                                                    <th
                                                        data-field="user_name"
                                                        className="no-mobile"
                                                    >
                                                        Взято на обмін
                                                    </th>
                                                    <th
                                                        data-field="user_name"
                                                        className="no-mobile"
                                                    >
                                                        IMEI
                                                    </th>
                                                    <th
                                                        data-field="user_name"
                                                        className="no-mobile"
                                                    >
                                                        Стан
                                                    </th>
                                                    <th
                                                        data-field="user_name"
                                                        className="no-mobile"
                                                    >
                                                        Оцінено
                                                    </th>
                                                    <th data-field="user_name">Сервіс</th>
                                                    <th
                                                        data-field="user_date"
                                                        className="no-mobile"
                                                    >
                                                        Дата
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orders.data.map((order) => {
                                                    return (
                                                        <tr key={order.id}>
                                                            <td className="check_area text-right">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        id="check_u5431"
                                                                        checked={ordersList.includes(
                                                                            order.id.toString()
                                                                        )}
                                                                        value={order.id}
                                                                        onChange={(e) => listCheckHandler(e)}
                                                                    />
                                                                    <label className="custom-control-label">
                                                                        &nbsp;
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="no-wrap">
                                                                    <Link
                                                                        to={"/order/" + order.id}
                                                                        data-id="178641"
                                                                        className="mobile-select"
                                                                    >
                                                                        Замовлення&nbsp;#{order.id}
                                                                    </Link>
                                                                </div>

                                                                <div className="product_store">{order.store.title}</div>
                                                                {/* <div className="on-mobile">02.03.2023</div> */}
                                                            </td>
                                                            <td className="no-mobile">
                                                                <Link to={"/product/" + order.product_id}>
                                                                    {order.exchange_title}
                                                                </Link>
                                                            </td>
                                                            <td className="no-mobile">{order.exchange_imei_sn}</td>
                                                            <td className="no-mobile">{order.exchange_status}</td>
                                                            <td className="no-mobile">{order.exchange_price}</td>
                                                            <td>
                                                                {order.exchange_is_service ? (
                                                                    <i
                                                                        className="bi bi-wrench-adjustable-circle"
                                                                        style={{
                                                                            fontSize: 18,
                                                                            color: "#0d6efd",
                                                                        }}
                                                                    ></i>
                                                                ) : (
                                                                    "Ні"
                                                                )}
                                                            </td>
                                                            <td className="fit no-mobile">
                                                                {moment(order.created_at).format("DD.MM.YYYY")}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                        <nav>
                                            <PaginatedItems
                                                pageCount={1} //orders.last_page
                                                setCurrentPage={setCurrentPage}
                                            />
                                        </nav>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Exchanges;
